import React from 'react'
import { Card, CardHeader } from '@material-ui/core'

export const Dashboard = () => (
  <Card>
    <CardHeader title="meuSucesso Admin Platform" />
  </Card>
)
